import React, {useEffect} from 'react';

import HillShader from '../../utils/hillshade';
import {RasterService} from '../../utils/RasterService';

//
// The hillshader doesn't work properly -- always returning -1... no time to debug though
//

const MapTopography = ({Map, layerConfig}) => {
    let rasterLayer = null; 
    let hillShadeLayer = null;

    const hillShader = (async function(config, stateAttribute) {
        if (!config.url) return;
        let pixelValuesToColorFn = config.pixelValuesToColorFn;

        const raster = await RasterService.createRaster(config.url, pixelValuesToColorFn, {
            opacity: config.opacity,
            resolution: config.resolution,
            // customDrawFunction
            //  values, w, h, context, x, y, width, height, rasters: tileRasters
            customDrawFunction: (props) => {
                let { values, w, h, context, x, y, width, height, rasters } = props
                let {
                    rasterX, rasterY, sampleX, sampleY, sampledRaster
                } = props

                if (Math.random() < 0.001) {
                    console.log(props)
                }

                let greyColor = HillShader({
                    x: sampleX,
                    y: sampleY,
                    width: sampledRaster[0][0].length,
                    height:  sampledRaster[0].length,
                    raster: sampledRaster[0],
                    nodatavalue: -32767
                }) * 255;
                let alpha = 0.7;

                if (greyColor < 0) {
                    alpha = 0;
                }

                context.fillStyle = (`rgba(${greyColor}, ${greyColor}, ${greyColor}, ${alpha}`);
                context.fillRect(x, y, width, height);
            }
        });
        raster.setZIndex(config.zIndex-1);
        raster.addTo(Map);
        hillShadeLayer = raster;
    });

    const initRaster = (async function(config) {
        if (!config.url) return;
        let pixelValuesToColorFn = config.pixelValuesToColorFn;
    
        const raster = await RasterService.createRaster(config.url, pixelValuesToColorFn, {
          resolution: config.resolution,
          opacity: config.opacity
        });
        raster.setZIndex(config.zIndex);
        raster.addTo(Map);
        rasterLayer = raster
      });


    useEffect(() => {

        if (!Map) return;

    
        hillShader(layerConfig)
        initRaster(layerConfig)

        return function cleanup() {
            if (rasterLayer) rasterLayer.remove();
            if (hillShadeLayer) hillShadeLayer.remove()
        }

    }, [Map])

    return null;
}

export default MapTopography;
